import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-[60px] md:pt-[80px] lg:pt-[100px] xl:pt-[150px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_PageTitle = _resolveComponent("PageTitle")!
  const _component_OurTeam = _resolveComponent("OurTeam")!
  const _component_CTA = _resolveComponent("CTA")!
  const _component_LightDarkModeBtn = _resolveComponent("LightDarkModeBtn")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Navbar),
    _createVNode(_component_PageTitle, { pageTitle: "Our Team" }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_OurTeam)
    ]),
    _createVNode(_component_CTA),
    _createVNode(_component_LightDarkModeBtn)
  ]))
}